import "./data/yup-validation";
import React from "react";
import { createRoot } from "react-dom/client";
import { navigate } from "utils/navigation";
import DevTools from "utils/dev-tools";
import Settings from "./settings";
import "./styles/main.scss";
import App from "./router";

declare global {
  interface Window {
    navigate: typeof navigate;
    devTools: typeof DevTools;
  }
}

// expose modules for testing with Cypress
if (Settings.env === "development" || Settings.env === "test") {
  window.navigate = navigate;
}

window.devTools = DevTools;
if (Settings.env === "development" || Settings.env === "test") {
  DevTools.enableDebug();
}

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
